import { AreaChart, Area, XAxis, YAxis, ResponsiveContainer, Tooltip } from "recharts";
import { DashboardCard } from "@/shared/ui/DashboardCard";
import { ChartTooltip } from "@/shared/ui/ChartTooltip";
import { useChartTheme } from "@/shared/hooks/useChartTheme";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { revenueData } from "../data";

export function RevenueChart() {
  const { tick } = useChartTheme();
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.ecommerce.revenueOverview} className="col-span-full md:col-span-2">
      <ResponsiveContainer width="100%" height={240}>
        <AreaChart data={revenueData} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="revenueGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#4680ff" stopOpacity={0.25} />
              <stop offset="100%" stopColor="#4680ff" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: tick, fontSize: 12 }}
            dy={8}
            tickFormatter={(v) => t.common.months[v] ?? v}
          />
          <YAxis hide />
          <Tooltip content={<ChartTooltip />} />
          <Area type="monotone" dataKey="revenue" stroke="#4680ff" strokeWidth={2.5} fill="url(#revenueGrad)" />
        </AreaChart>
      </ResponsiveContainer>
    </DashboardCard>
  );
}
